// Librerias
import React from 'react'
let PropTypes = React.PropTypes
import * as css from '../../diferencias-inventarios/TablaInventarios.css'


export class RowInventario extends React.Component {
    constructor(props) {
        super(props)
    }
    render(){
        return (
            <tr key={1}>
                <td>{this.props.correlativo}</td>
                <td className={css.tdFecha}>{this.props.inventario.inv_fechaProgramadaF}</td>
                <td>{this.props.inventario.cliente_nombre}</td>
                <td className={css.tdCeco}>{this.props.inventario.local_ceco}</td>
                <td>{this.props.inventario.local_nombre}</td>
                <td className={css.tdInf}>{this.props.inventario.inv_unidadesReal}</td>
                <td className={css.tdUnidadSEI}>{this.props.inventario.inv_diferenciaInfReal}</td>
                <td className={css.tdUnidadSEI}>{this.props.inventario.inv_hes}</td>
                <td className={css.tdUnidadSEI}>{this.props.inventario.total_servicio}</td>
            </tr>
        )
    }
}
RowInventario.propTypes = {
    inventario: PropTypes.object,
    correlativo: PropTypes.number,
    aprobacionCliente: PropTypes.func,
    aprobacionSei: PropTypes.func,
}


// WEBPACK FOOTER //
// ./frontEnd/inventarios/inventarios-facturacion/serviciosRealizados/RowInventario.jsx